import { Card, CardContent } from "@/components/ui/card";
import { ReactNode } from "react";

interface EventCardProps {
  title: string;
  prize: string;
  entryFee: string;
  venue?: string;
  teamSize?: string;
  icon: ReactNode;
  description: string;
  borderColor: string;
  titleColor: string;
}

export default function EventCard({ 
  title, 
  prize, 
  entryFee, 
  venue, 
  teamSize, 
  icon, 
  description, 
  borderColor,
  titleColor 
}: EventCardProps) {
  return (
    <Card className={`card-hover bg-gradient-to-br from-card to-muted/20 rounded-xl border ${borderColor} transition-all duration-300 hover:scale-105`}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className={`font-bold text-2xl ${titleColor}`}>{title}</h3>
          <div className="w-12 h-12 bg-gradient-to-r from-primary to-cyan-400 rounded-lg flex items-center justify-center">
            {icon}
          </div>
        </div>
        
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Prize Pool:</span>
            <span className="font-bold text-green-400">{prize}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Entry Fee:</span>
            <span className="font-bold">{entryFee}</span>
          </div>
          {venue && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Venue:</span>
              <span className="font-bold">{venue}</span>
            </div>
          )}
          {teamSize && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Team Size:</span>
              <span className="font-bold">{teamSize}</span>
            </div>
          )}
        </div>
        
        <p className="text-muted-foreground mt-4 text-sm">
          {description}
        </p>
      </CardContent>
    </Card>
  );
}
